import { useState } from 'react';

const useForm = ({ initialValue, onSubmit, validate }) => {
  const [values, setValues] = useState(initialValue || {});
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    const newErrors = validate ? validate(values) : {};
    try {
      if (Object.keys(newErrors).length === 0) {
        await onSubmit(values);
        setValues(initialValue);
      }
      setErrors({ ...newErrors, badRequest: false });
    } catch (error) {
      if (error) {
        const { response } = error;
        if (response) {
          const { status } = response;
          if (status === 400) {
            setErrors({ ...newErrors, badRequest: true });
          }
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    values,
    errors,
    isLoading,
    handleChange,
    handleSubmit,
  };
};

export default useForm;
